module.exports = __webpack_public_path__ + "static/engineering-051298afa3d4e2bbb4d26013ee48bedb.jpg";